import {
  PROPOSE_TASK_GET, PROPOSE_TASK_GET_FAILURE, PROPOSE_TASK_GET_SUCCESS
} from './mutation-types'

export default {
  state: {
    proposeTask: {}
  },
  getters: {
    proposeTask: state => {
      return state.proposeTask
    }
  },
  actions: {
    [PROPOSE_TASK_GET] ({dispatch, state, commit}, params = null) {
      var url = '/asovi/propose_tasks/'
      var data = {}
      var callback = null
      if (params) {
        data = params.data
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROPOSE_TASK_GET_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROPOSE_TASK_GET_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    }
  },
  mutations: {
    [PROPOSE_TASK_GET_FAILURE] (state, data) {
      console.log('PROPOSE_TASK_GET_FAILURE')
    },
    [PROPOSE_TASK_GET_SUCCESS] (state, data) {
      console.log('PROPOSE_TASK_GET_SUCCESS')
      state.proposeTask = data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/propose-task.js